import UiSelectOption from "./UiSelectOption";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export enum EnumOrderPoolGrossProfitStatus {
    /**
     * 正
     */
    Zheng = 10,
    /**
     * 负
     */
    Fu = 20,
}

/**
 * -选项
 */
export const EnumOrderPoolGrossProfitStatusOption: UiSelectOption<number>[] = [
    { Label: "正", Value: 10, Data: "Zheng" },
    { Label: "负", Value: 20, Data: "Fu" },
];
